<div class="container">
  <div class="row">
    <div class="title">{{ "followUpParent.title" | translate }}</div>
  </div>
  <div class="row marginTop64">
    <div class="subtitle">
      {{ "moduleCompletion.profileManagement" | translate }}
    </div>
  </div>
  <div class="buttonsContainer marginTop24">
    @if (user) {
      <div
        (click)="addParent()"
        [class.disabled]="shouldDisableAddButton(Role.parent)"
        class="button primary ctaBtn"
        >
        <i class="bi bi-plus-circle-fill"></i
          >{{ "followUpParent.addParentButton" | translate }}
        </div>
      }
      @if (user) {
        <div
          (click)="addChild()"
          [class.disabled]="shouldDisableAddButton(Role.enfant)"
          class="button primary ctaBtn"
          >
          <i class="bi bi-plus-circle-fill"></i>
          {{ "followUpParent.addChildButton" | translate }}
        </div>
      }
    </div>
    <div class="row marginTop64">
      <div class="subtitle">{{ "followUpParent.followUp" | translate }}</div>
    </div>
    <div class="tableContainer">
      @for (follow of followup; track follow; let i = $index) {
        <div
          class="rowContainer"
          >
          <div (click)="displayDetailsFor(follow)" class="content">
            <div class="name">
              {{ getNameFor(follow) }}
            </div>
            <div class="disclosureIndicator">
              <i class="bi bi-chevron-right"></i>
            </div>
          </div>
          @if (!(i === followup.length - 1)) {
            <div class="divider"></div>
          }
        </div>
      }
    </div>
  </div>
